import { UpdateUspsLocationState } from './updateUspsLocation.types'

const initialState: UpdateUspsLocationState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
